<style>
</style>

<template>
  <v-menu
    v-model="show"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
  >
    <v-list>
      <v-list-tile @click="selectMenuItem(item.key)" :key="item.key" v-for="item in menuItems">
        <v-list-tile-title>{{item.text}}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    menuItems: {
      type: Array,
      required: true
    },
  },
  data: () => ({
    show: false,
    x: 0,
    y: 0
  }),
  methods: {
    selectMenuItem(type) {
      this.$emit('selected', type);
    },
    showMenu(e) {
      e.preventDefault();
      this.show = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/edition/components/TableDataMenu.vue